/* Klyk sustainability section: interactions. Theme asset: klyk-sustainability.js */
(function(){
var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function load(src){ return new Promise(function(res, rej){ var s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); }); }
var libs = null;
function getLibs(){ if (!libs) libs = (window.d3 ? Promise.resolve() : load('https://unpkg.com/d3@7.9.0/dist/d3.min.js')).then(function(){ return window.topojson ? null : load('https://unpkg.com/topojson-client@3.1.0/dist/topojson-client.min.js'); }).then(function(){ return d3.json('https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/countries-110m.json'); }); return libs; }
var KEYS = ['rare','gallium','tantalum','cobalt','lithium','graphite','tin','copper'];
var C = {
  CN:{id:'156',at:[104,35],n:'China',a:'middle',dx:0,dy:-26}, US:{id:'840',at:[-98,39],n:'USA',a:'start',dx:10,dy:4},
  AU:{id:'036',at:[134,-25],n:'Australia',a:'middle',dx:0,dy:22}, MM:{id:'104',at:[96,21],n:'Myanmar',a:'end',dx:-10,dy:4},
  MY:{id:'458',at:[102.5,4],n:'Malaysia',a:'end',dx:-12,dy:14}, CD:{id:'180',at:[23.6,-2.9],n:'DRC',a:'end',dx:-10,dy:4},
  RW:{id:'646',at:[29.9,-2],n:'Rwanda',a:'start',dx:10,dy:4}, NG:{id:'566',at:[8,9.5],n:'Nigeria',a:'end',dx:-10,dy:4},
  BR:{id:'076',at:[-51,-10],n:'Brazil',a:'start',dx:10,dy:4}, CL:{id:'152',at:[-70.5,-30],n:'Chile',a:'end',dx:-10,dy:4},
  ZW:{id:'716',at:[29.8,-19],n:'Zimbabwe',a:'end',dx:-10,dy:4}, AR:{id:'032',at:[-65,-35],n:'Argentina',a:'start',dx:10,dy:12},
  TZ:{id:'834',at:[35,-6.3],n:'Tanzania',a:'start',dx:10,dy:4}, MZ:{id:'508',at:[35.5,-18],n:'Mozambique',a:'start',dx:10,dy:10},
  ID:{id:'360',at:[106,-2.2],n:'Indonesia',a:'start',dx:10,dy:14}, PE:{id:'604',at:[-75,-9.5],n:'Peru',a:'end',dx:-10,dy:4}
};
var M = {
  rare:[['CN','69%','91%'],['US','13%'],['AU','7%'],['MM','6%'],['MY',null,'']],
  gallium:[['CN','99%']],
  tantalum:[['CD','52%'],['RW','16%'],['NG','15.6%'],['BR','7.6%']],
  cobalt:[['CD','~75%'],['CN',null,'most']],
  lithium:[['AU','31.7%'],['CN','21.4%','70%'],['CL','19.3%'],['ZW',''],['AR','']],
  graphite:[['CN','82%'],['TZ',''],['MZ','']],
  tin:[['CN','23%'],['ID',''],['MM',''],['PE','']],
  copper:[['CL',''],['CD',''],['PE','']]
};
var HUB = [-0.12,51.5];

function MapView(el){
  var self = this, svg, proj, W, H, small, gArc, gMark, gLbl, countries, timers = [];
  this.played = false; this.sel = null;
  function entries(){
    if (self.sel && M[self.sel]) return M[self.sel].map(function(e){ return { k:e[0], m:e[1], r:e[2] }; });
    var u = {};
    Object.keys(M).forEach(function(key){ M[key].forEach(function(e){
      var o = u[e[0]] || (u[e[0]] = { k:e[0], m:null, r:undefined });
      if (e[1] !== null && e[1] !== undefined) o.m = '';
      if (e[2] !== undefined) o.r = '';
    }); });
    return Object.keys(u).map(function(k){ return u[k]; });
  }
  function base(){
    el.innerHTML = '';
    W = el.clientWidth || 800; H = el.clientHeight || 400; small = W < 560;
    svg = d3.select(el).append('svg').attr('viewBox', '0 0 ' + W + ' ' + H).attr('role','img').attr('aria-label','World map showing where the critical materials in a laptop are mined and refined').style('width','100%').style('height','100%').style('display','block');
    proj = d3.geoNaturalEarth1().fitExtent([[4,4],[W-4,H-4]], { type:'FeatureCollection', features: countries });
    svg.append('g').selectAll('path').data(countries).join('path').attr('class','km-land').attr('d', d3.geoPath(proj));
    gArc = svg.append('g'); gMark = svg.append('g'); gLbl = svg.append('g');
  }
  function label(x, y, a, text, cls){
    var t = gLbl.append('text').attr('class', 'km-lbl ' + cls).attr('x', x).attr('y', y).attr('text-anchor', a).style('font-size', (small ? 10 : 11) + 'px').text(text);
    var b = t.node().getBBox(), shift = b.x + b.width > W - 6 ? (W - 6) - (b.x + b.width) : b.x < 6 ? 6 - b.x : 0;
    if (shift) { t.attr('x', x + shift); b = t.node().getBBox(); }
    gLbl.insert('rect', 'text').attr('class', cls).attr('x', b.x - 4).attr('y', b.y - 2).attr('width', b.width + 8).attr('height', b.height + 4).attr('rx', 3).attr('fill', '#FAF5EB');
  }
  this.render = function(animate){
    if (!svg) return;
    timers.forEach(clearTimeout); timers = [];
    gArc.selectAll('*').interrupt().remove(); gMark.selectAll('*').remove(); gLbl.selectAll('*').remove();
    var list = entries(), ids = {}; list.forEach(function(e){ ids[C[e.k].id] = 1; });
    svg.selectAll('.km-land').classed('on', function(d){ return self.played && !!ids[d.id]; });
    if (!self.played) return;
    var hub = proj(HUB), sel = self.sel;
    function gc(a,b){ var i = d3.geoInterpolate(a,b); return d3.line()(d3.range(0,1.0001,1/48).map(function(t){ return proj(i(t)); })); }
    list.forEach(function(e,k){
      var c = C[e.k], p = proj(c.at), x = p[0], y = p[1], cls = 'km-fade s' + k;
      var arc = gArc.append('path').attr('d', gc(c.at, HUB)).attr('fill','none').attr('stroke','#CE6645').attr('stroke-width',1.25).attr('stroke-linecap','round');
      var L = arc.node().getTotalLength(); arc.attr('stroke-dasharray', L).attr('stroke-dashoffset', animate && !reduced ? L : 0);
      if (e.r !== undefined) {
        gMark.append('circle').attr('class', cls).attr('cx',x).attr('cy',y).attr('r',8).attr('fill','none').attr('stroke','#272727').attr('stroke-width',2);
        if (e.m === null) gMark.append('circle').attr('class', cls).attr('cx',x).attr('cy',y).attr('r',2.5).attr('fill','#272727');
      }
      if (e.m !== null) {
        gMark.append('path').attr('class','km-pop s' + k).attr('fill','#272727').attr('d', 'M' + x + ',' + y + ' c-4,-6 -7,-9 -7,-13 a7,7 0 1,1 14,0 c0,4 -3,7 -7,13 z');
        gMark.append('circle').attr('class','km-pop s' + k).attr('cx',x).attr('cy',y-13).attr('r',2.4).attr('fill','#FAF5EB');
      }
      if (sel) {
        var t = c.n;
        if (!small) { if (e.m) t += ' ' + e.m; if (e.r !== undefined) t += ' · refines' + (e.r ? ' ' + e.r : ''); }
        label(x + c.dx, y + c.dy, c.a, t, cls);
      }
    });
    gMark.append('circle').attr('class','km-fade hub').attr('cx',hub[0]).attr('cy',hub[1]).attr('r',7).attr('fill','#F29B00').attr('stroke','#272727').attr('stroke-width',1.5);
    label(hub[0] - 12, hub[1] - 12, 'end', 'Your laptop', 'km-fade hub');
    function show(k){ svg.selectAll('.s' + k).classed('on', true); }
    if (!animate || reduced) { list.forEach(function(e,k){ show(k); }); svg.selectAll('.hub').classed('on', true); gArc.selectAll('path').attr('stroke-dashoffset', 0); return; }
    var step = sel ? 140 : 60;
    list.forEach(function(e,k){ timers.push(setTimeout(function(){ show(k); }, 80 + k * step)); });
    timers.push(setTimeout(function(){
      svg.selectAll('.hub').classed('on', true);
      gArc.selectAll('path').each(function(d,i){ d3.select(this).transition().delay(i * (sel ? 120 : 40)).duration(1100).ease(d3.easeCubicInOut).attr('stroke-dashoffset', 0); });
    }, 80 + list.length * step));
  };
  this.select = function(key){ var next = key || null; if (next === self.sel) return; self.sel = next; self.render(self.played); };
  this.play = function(){ if (self.played) return; self.played = true; self.render(true); };
  this.ready = getLibs().then(function(topo){
    countries = topojson.feature(topo, topo.objects.countries).features.filter(function(f){ return f.id !== '010'; });
    base(); self.render(false);
    var rt, lastW = el.clientWidth;
    window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(function(){ if (el.clientWidth === lastW) return; lastW = el.clientWidth; base(); self.render(false); }, 150); });
  });
}

document.querySelectorAll('.klyk-sus').forEach(function(root){
  var rev = root.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px' });
    rev.forEach(function(el){ io.observe(el); });
  } else rev.forEach(function(el){ el.classList.add('is-in'); });

  // device selector
  var devBtns = root.querySelectorAll('[data-act="dev"]');
  devBtns.forEach(function(b){ b.addEventListener('click', function(){
    var i = b.getAttribute('data-i');
    devBtns.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    root.querySelectorAll('[data-devp]').forEach(function(p){ p.hidden = p.getAttribute('data-devp') !== i; });
  }); });

  // materials + map
  var mapEl = root.querySelector('[data-map]'), map = null, cur = -1;
  if (mapEl) {
    map = new MapView(mapEl);
    var start = function(){ map.ready.then(function(){ map.play(); }); };
    if ('IntersectionObserver' in window) { var mo = new IntersectionObserver(function(es){ if (es[0].isIntersecting) { start(); mo.disconnect(); } }, { threshold: 0.35 }); mo.observe(mapEl); } else start();
  }
  var matBtns = root.querySelectorAll('[data-act="mat"]');
  function pickMat(i){
    cur = i;
    matBtns.forEach(function(x){ x.setAttribute('aria-pressed', String(+x.getAttribute('data-i') === i)); });
    root.querySelectorAll('[data-matp]').forEach(function(p){ p.hidden = p.getAttribute('data-matp') !== (i < 0 ? 'all' : String(i)); });
    if (map) map.ready.then(function(){ map.select(i < 0 ? null : KEYS[i]); });
  }
  matBtns.forEach(function(b){ b.addEventListener('click', function(){ var i = +b.getAttribute('data-i'); pickMat(cur === i ? -1 : i); }); });
  root.addEventListener('click', function(e){ if (e.target.closest('[data-act="mat-all"]')) pickMat(-1); });

  // FAQs
  var faqs = root.querySelectorAll('[data-act="faq"]');
  faqs.forEach(function(btn){ btn.addEventListener('click', function(){
    var open = btn.getAttribute('aria-expanded') === 'true';
    faqs.forEach(function(b){ b.setAttribute('aria-expanded', 'false'); b.nextElementSibling.style.display = 'none'; b.lastElementChild.style.transform = 'rotate(0deg)'; });
    if (!open) { btn.setAttribute('aria-expanded', 'true'); btn.nextElementSibling.style.display = 'block'; btn.lastElementChild.style.transform = 'rotate(45deg)'; }
  }); });
});
})();
